import script from "./FintechPuzzle.vue?vue&type=script&setup=true&lang=js"
export * from "./FintechPuzzle.vue?vue&type=script&setup=true&lang=js"

import "./FintechPuzzle.vue?vue&type=style&index=0&id=01ffb0ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ffb0ec"]])

export default __exports__